import React from "react";
import moment from "moment";
import { component_tool } from '../../../../tool'

let { WizDataTable, WizButton } = component_tool


const formatterDate = (val) => {
  return val ? moment(val).format('YYYY-MM-DD HH:mm') : '';
}

export default (self) => {
  let columns = []
  columns = columns.concat([
    {
      title: "名称",
      name: "name",
      searchItem: {},
      tableItem: {}
    },
    {
      title: "计划安排时间",
      name: "applyPlanTime",
      tableItem: {
        render: (text, record) => {
          const { startTime, endTime } = record;
          return formatterDate(startTime) + " ~ " + formatterDate(endTime)
        }
      },
      searchItem: {
        type: 'date~',
        format: 'YYYY-MM-DD HH:mm',
        showTime: {
          format: 'HH:mm'
        }
      }
    },
    {
      title: "地点",
      name: "address",
      tableItem: {}
    },
    {
      title: "限制人数",
      name: "limitCount",
      tableItem: {
        render: (text, record) => {
          if (text < 0) {
            text = '不限制'
          }
          return text
        }
      }
    },
    {
      title: "报名人数",
      name: "applyNumber",
      tableItem: {
        render: (text, record) => (
          <WizDataTable.Oper>
            <WizButton
              tooltip={text}
              onClick={() => {
                self.filters={planId: record.id}
                self.setState({ planActivityKey: "2", planId: record.id, resetType:1 })
                self._applyRecordList({ planId: record.id });
              }}>
              {text}
            </WizButton>
          </WizDataTable.Oper>
        )
      }
    },
    {
      title: "待审核人数",
      name: "reviewNumber",
      tableItem: {
        render: (text, record) => (
          <WizDataTable.Oper>
            <WizButton
              tooltip={text}
              onClick={() => {
                self.filters={planId: record.id, status: 0}
                self.setState({ planActivityKey: "2", planId: record.id, status: 0, resetType:1 })
                self._applyRecordList({ planId: record.id, status: 0 });
              }}>
              {text}
            </WizButton>
          </WizDataTable.Oper>
        )
      }
    },
    {
      title: "通过人数",
      name: "passNumber",
      tableItem: {
        render: (text, record) => (
          <WizDataTable.Oper>
            <WizButton
              tooltip={text}
              onClick={() => {
                self.filters={planId: record.id, status: 1}
                self.setState({ planActivityKey: "2", planId: record.id, status: 1, resetType:1 })
                self._applyRecordList({ planId: record.id, status: 1 });

              }}>
              {text}
            </WizButton>
          </WizDataTable.Oper>
        )
      }
    },
    {
      title: "未通过人数",
      name: "noPassNumber",
      tableItem: {
        render: (text, record) => (
          <WizDataTable.Oper>
            <WizButton
              tooltip={text}
              onClick={() => {
                self.filters={planId: record.id, status: 3}
                self.setState({ planActivityKey: "2", planId: record.id, status: 3, resetType:1 })
                self._applyRecordList({ planId: record.id, status: 3 });
              }}>
              {text}
            </WizButton>
          </WizDataTable.Oper>
        )
      }
    },
    {
      title: '安排状态',
      name: 'state',
      tableItem: {},
      dict: [
        { code: 0, codeName: '无效' },
        { code: 1, codeName: '有效' },
      ]
    }
  ])
  return columns;
}
